import PropTypes from "prop-types";
import { AppBar, Toolbar, Typography } from "@mui/material";
import version from "src/../package.json";
import ConnectedIcon from "src/components/icons/purposed/ConnectedIcon";
import TestApi_light from "src/components/tests/TestApi_light";
import TestSql_light from "src/components/tests/TestSql_light";
import { useContext } from "react";
import { userContext } from "src/context/userContext";
import CacheSize from "src/components/system/CacheSize";

export default function FooterBar(props) {
  const noInfo = props.noInfo || false;

  const { isLoggedIn } = useContext(userContext) || {};

  return (
    <div className="noPrint">
      <AppBar position="static" color="secondary" sx={{ height: "70px" }}>
        <Toolbar className="spaceBetween">
          <div>
            <Typography>PumiNet Oy</Typography>
            {!noInfo && <Typography fontSize="small">3091336-1</Typography>}
          </div>
          <div>
            {!noInfo && (
              <>
                <a href="mailto:tuki@betoni.online">
                  <Typography variant="body2" align="center">
                    tuki@betoni.online
                  </Typography>
                </a>
                <a href="tel:+358405334611">
                  <Typography variant="body2" align="center">
                    040 533 4611
                  </Typography>
                </a>
              </>
            )}
          </div>
          <div style={{ paddingRight: "20px" }}>
            <div style={{ display: "flex", opacity: 0.8 }}>
              <VersionNum />
              <CacheSize text="c" />
              <TestApi_light />
              <TestSql_light />
            </div>
            {isLoggedIn && (
              <Typography fontSize="small" variant="body2" color="primary">
                <ConnectedIcon variant="number" /> käyttäjää online
              </Typography>
            )}
          </div>
        </Toolbar>
      </AppBar>
    </div>
  );

  function VersionNum() {
    return <Typography variant="body2">{"v" + version.version}</Typography>;
  }
}

FooterBar.propTypes = {
  noInfo: PropTypes.bool,
};
